import React from 'react';
import _ from 'lodash';

import {
  Tier1ReturnAuthorizationDetailActivity_ActionBarQuery,
  TriageWorkflowTypeName,
  useTier1ReturnAuthorizationDetailActivity_ActionBarQuery
} from 'generated/graphql';



export type IStatus = 'preAlert' | 'itemReceived' | 'observationComplete' | 'triageComplete' | 'qualityControlComplete' | 'complete';

export interface IData {
  storeId: string;
  enabledWorkflows: TriageWorkflowTypeName[];
  status: IStatus;
}

export function useQuery(id: string) {
  const tuple = useTier1ReturnAuthorizationDetailActivity_ActionBarQuery({
    variables: {
      returnAuthorizationId: id
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        enabledWorkflows: _.map(_.filter(tuple.data?.tier1ReturnAuthorization?.group.store.triageWorkflows, wf => wf.isEnabled), wf => wf.type.name),
        storeId: tuple.data?.tier1ReturnAuthorization?.group.store.id ?? '',
        status: __getStatus(tuple.data?.tier1ReturnAuthorization)
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



function __getStatus(returnAuthorization?: Tier1ReturnAuthorizationDetailActivity_ActionBarQuery['tier1ReturnAuthorization']): IStatus {
  if (!returnAuthorization) {
    return 'preAlert';
  }

  const {
    observation,
    selectedTriage,
    qualityControlCheck,
    itemReceipt,
    carton
  } = returnAuthorization;

  const triageType = selectedTriage?.workflow.type.name;

  if (!_.isNil(carton)) {
    return 'complete';
  }

  if (triageType === 'credit' || triageType === 'scrap') {
    return 'complete';
  }

  if (qualityControlCheck) {
    return 'qualityControlComplete';
  }

  if (selectedTriage) {
    return 'triageComplete';
  }

  if (observation) {
    return 'observationComplete';
  }

  if (itemReceipt) {
    return 'itemReceived';
  }

  return 'preAlert';
}
